/** Client-side table sort helpers. */

export function compareSortValues(a, b) {
  if (a === b) return 0
  if (a == null || a === '') return 1
  if (b == null || b === '') return -1
  if (typeof a === 'number' && typeof b === 'number') return a - b
  if (typeof a === 'boolean' && typeof b === 'boolean') {
    return Number(a) - Number(b)
  }
  return String(a).localeCompare(String(b), undefined, {
    numeric: true,
    sensitivity: 'base',
  })
}

export function sortRows(rows, sortBy, sortDir, columns) {
  if (!sortBy || !rows.length) return rows
  const col = columns.find((c) => c.id === sortBy)
  if (!col?.sortValue) return rows
  const dir = sortDir === 'desc' ? -1 : 1
  return [...rows].sort((left, right) => {
    const cmp = compareSortValues(col.sortValue(left), col.sortValue(right))
    return cmp * dir
  })
}
